import { Api } from './baseApi';
import { IMenuResponse } from './swaggerTypes';

export async function getMainMenu(): Promise<IMenuResponse> {
  return Api.get<IMenuResponse>('CustomTypes/Menu');
}
